import { EditButton, ReferenceManyField, Show,
  ShowProps, SimpleShowLayout, Tab,
  TabbedShowLayout, TextField } from "react-admin";
import { NotesList } from "../note/notes-list";
import { TopToolBar } from "../shared-components";
import { BackToProfile } from "./address-top-toolbar";
import AddressMap from "./map/address-map";


export const ShowAddressTitle: React.FC = ( data: any) => {
  return <a style={{color: '#ffffff', textDecoration: 'none'}} href={`#/profiles/${data.record.user_id}/show/addresses`}><span style={{fontWeight: 600}}>{data.record.userName}</span> {data.record.user_id} </a>;
};

const Aside = (props:any) => {
  return( <div style={{ width: '60%'}}>
    <AddressMap records={{oldRecord: props.record}} />
  </div>
  );
}


export const AddressShow: React.FC<ShowProps> = (props) => {
  const notesPath = props.location?.pathname.includes('notes');
  const ShowActions = (data: any) => {
    return (
      <TopToolBar left={<BackToProfile userID={data?.data?.user_id}/>} right={notesPath ? null : <EditButton basePath={data.basePath} record={data.data} />}/>
    )};
  return (
    <Show title={<ShowAddressTitle/>} actions={<ShowActions/>} aside={notesPath ? undefined : <Aside {...props} />} {...props}>
      <TabbedShowLayout>
        <Tab label="Address info">
          <SimpleShowLayout>
            <TextField source="id" label="ID"/>
            <TextField source="full_address" label="Address"/>
            <TextField source="apt" label="Apt"/>
            <TextField source="district" label="District"/>
            <TextField source="city" label="City"/>
            <TextField source="state" label="State"/>
            <TextField source="zip" label="Zip"/>
            <TextField source="delivery_note" label="Delivery Note"/>
          </SimpleShowLayout>
        </Tab>
        <Tab label="Notes" path="notes">
          <ReferenceManyField reference="notes" target="id" filter={{ id: props.id }} addLabel={false} {...props}>
            <NotesList {...props} />
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  )};
